import "./App.css";

export const Loading = () => {
  const year = new Date().getFullYear();
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex justify-between bg-unleashed-gray p-1">
        <img className="mx-auto inline-block object-scale-down h-9"
          src="/banner.svg" alt="Unleashed Brands banner"/>
      </div>
      <div className="flex-grow flex justify-center items-center">
        <div className="bg-black absolute inset-0 opacity-30"/>
        <img className="z-10 max-h-24 max-w-24" src="/spinner.gif"
          alt="spinner"/>
      </div>
      <div className="bg-unleashed-gray p-1 text-white">
        <div className="text-xs text-center">
          {/*This can't be translated due to i18n being uninitialized at this point*/}
          Copyright © {year} Unleashed Brands. All rights reserved.
        </div>
      </div>
    </div>
  );
};
